import React from 'react';
import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import EmailBodySubComponent from '../../../../../components/email-services/EmailBodySubComponent';
import ImageComponent from '../../../../../components/email-services/services-library/image-component/ImageComponent';
import TextComponent from '../../../../../components/email-services/services-library/text-component/TextComponent';
import {
  COMPONENT_LIST,
  EMAIL_BODY,
  EMAIL_FOOTER,
  EMAIL_HEADER,
  EMAIL_IMAGE_COMPONENT,
  EMAIL_SOCIAL_TEXT_COMPONENT,
  EMAIL_TEXT_COMPONENT,
} from '../../../../../constants/EmailServicesConst';

const GuestRightPanel = (props) => {
  const {
    activeSection,
    onItemChange,
    componentsList,
    activeNdx,
    onClickBack,
    setIsDragged,
    setActiveSection,
    onRemoveComponent,
    groupId,
  } = props;

  const setTitle = () => {
    if (activeSection === EMAIL_HEADER) return 'Header';
    if (activeSection === EMAIL_BODY) return 'Body';
    if (activeSection === EMAIL_FOOTER) return 'Footer';
  };

  const onDragStart = (e, component) => {
    e.dataTransfer.setData('component', JSON.stringify(component));
    setIsDragged(true);
  };

  return (
    <div className='right-panel'>
      <div className='right-panel-header'>
        <p className='right-panel-header-title'>Edit {setTitle()}</p>
      </div>
      <div className='px-3'>
        {activeSection === EMAIL_HEADER && (
          <ImageComponent
            componentId={EMAIL_IMAGE_COMPONENT}
            onItemChange={onItemChange}
            componentObj={componentsList?.header}
            isRemovable={false}
            activeNdx={-1}
            isHex={true}
            groupId={groupId}
          />
        )}
      </div>
      {activeSection === EMAIL_BODY && (
        <div className='p-3'>
          <div className='right-panel-body'>
            {componentsList.body[activeNdx]?.id && activeNdx > -1 ? (
              <>
                <Button
                  variant='text'
                  color='secondary'
                  size='small'
                  startIcon={<ArrowBack />}
                  onClick={(e) => onClickBack(e)}
                  className='me-2'
                >
                  Back
                </Button>
              </>
            ) : (
              <p className='right-panel-body-title'>Components</p>
            )}
          </div>
          <div className='px-3'>
            <div className='w-100'>
              <div className='row'>
                {componentsList.body[activeNdx]?.id && activeNdx > -1 ? (
                  <EmailBodySubComponent
                    onItemChange={onItemChange}
                    componentObj={componentsList.body[activeNdx]}
                    activeNdx={activeNdx}
                    onRemoveComponent={onRemoveComponent}
                    groupId={groupId}
                  />
                ) : (
                  <>
                    {COMPONENT_LIST.map((listValue) => (
                      <div className='col-md-6' key={listValue.id}>
                        <div
                          className='right-panel-body-component-box p-2 d-flex flex-column  align-items-center justify-content-center'
                          draggable
                          onDragStart={(e) => onDragStart(e, listValue)}
                          onDragEnd={() => setIsDragged(false)}
                        >
                          <img src={listValue.image} alt={listValue.title} />
                          <div className='right-panel-body-component-box-title mt-2'>
                            {listValue.title}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {activeSection === EMAIL_FOOTER && (
        <div className='footer-scroll scroll-styled'>
          <div className='p-3'>
            <div className='px-2'>
              <Button
                variant='text'
                color='secondary'
                size='small'
                startIcon={<ArrowBack />}
                onClick={(e) => setActiveSection(null)}
                className='me-2 mb-2'
              >
                Back
              </Button>
              <ImageComponent
                componentId={EMAIL_IMAGE_COMPONENT}
                onItemChange={onItemChange}
                componentObj={componentsList?.footer.image}
                isRemovable={false}
                activeNdx={-1}
                isHex={false}
                groupId={groupId}
              />
              <div className='mt-3'>
                <TextComponent
                  componentId={EMAIL_TEXT_COMPONENT}
                  onItemChange={onItemChange}
                  componentObj={componentsList?.footer.text}
                  activeNdx={-1}
                  isHex={false}
                  isVariable={false}
                  placeHolderText='Text Input Field 1'
                  isFontStyleDD={false}
                  isHyperlink={false}
                />
              </div>
              <div className='mt-3'>
                <TextComponent
                  componentId={EMAIL_SOCIAL_TEXT_COMPONENT}
                  onItemChange={onItemChange}
                  componentObj={componentsList?.footer.social}
                  activeNdx={-1}
                  isHex={true}
                  isVariable={false}
                  placeHolderText='Text Input Field 2'
                  isFontStyleDD={false}
                  isHyperlink={false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuestRightPanel;
